/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ActionTree, GetterTree, MutationTree, Module } from 'vuex'
import { RootState } from '@/store'

// ts
export type RegisterCodeState = {
  registerCode: string | null;
};

const state: RegisterCodeState = {
  registerCode: null
}

const getters: GetterTree<RegisterCodeState, RootState> = {
  registerCode: state => state.registerCode
}

const actions: ActionTree<RegisterCodeState, RootState> = {
  register ({ commit }, params: string): Promise<void> {
    commit('registerCode', params)
    return Promise.resolve()
  },
  destroy ({ commit }): Promise<void> {
    commit('reset')
    return Promise.resolve()
  }
}

const mutations: MutationTree<RegisterCodeState> = {
  registerCode (state, registerCode) {
    state.registerCode = registerCode
  },
  reset (state) {
    state.registerCode = null
  }
}

const registerCode: Module<RegisterCodeState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default registerCode
